import { render, staticRenderFns } from "./ProductClass.vue?vue&type=template&id=bb3fe75c"
import script from "./ProductClass.vue?vue&type=script&lang=js"
export * from "./ProductClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports